import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'redux'

import {withModule} from '../redux/goose'
import AuthModule from '../redux/modules/auth/auth'
import analytics from '../util/analytics'
import LoaderOverlay from '../Components/LoaderOverlay'
import MessengerAuthContainer from './MessengerAuthContainer'
import BasicAuthContainer from './BasicAuthContainer'
import DevAuthContainer from './DevAuthContainer'

class AuthContainer extends React.Component{
  static propTypes = {
    ready: PropTypes.bool,
    mechanism: PropTypes.oneOf(['basic','messenger','dev','token']),
    children: PropTypes.object,
  }

  componentDidMount () {
    analytics.init()
  }

  getLoginContainer (mechanism) {
    switch (mechanism) {
      case 'messenger':
        return <MessengerAuthContainer />
      case 'basic':
        return <BasicAuthContainer />
      case 'dev':
        return <DevAuthContainer />
      default:
        return null
    }
  }

  render () {
    const { mechanism, ready, children } = this.props

    return (
      <React.Fragment>
        <LoaderOverlay.Toggle active={!ready} />
        {mechanism && this.getLoginContainer(mechanism)}
        {ready && children}
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  ready: state.auth.ready,
  mechanism: state.auth.mechanism
})

export default compose(
  withModule(AuthModule),
  connect(mapStateToProps)
)(AuthContainer)



// WEBPACK FOOTER //
// ./src/Containers/AuthContainer.js